import { Button, Row, Col, Modal } from "antd";
import React, { useEffect } from "react";
import { EnvironmentOutlined, FileTextOutlined, HomeOutlined, KeyOutlined, UserOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

import * as Common from "../commons/common";
import * as Utils from "../utils/utils";

import { AlertType, useAlert } from "../provider/AlertProvider";
import { useAuthDispatch } from "../provider/AuthProvider";
import styles from "./PageFooter.module.css";

function PageFooter() {
    const navigate = useNavigate();
    const dispatch = useAuthDispatch();
    const alert = useAlert();

    useEffect(() => {
        Utils.onEvent(Common.EVENT_CLOSE_ALL_MODAL, handleCloseAllModal);
        return () => {
            Utils.offEvent(Common.EVENT_CLOSE_ALL_MODAL, handleCloseAllModal);
        };
    }, []);

    const handleCloseAllModal = () => {
        Modal.destroyAll();
    };

    return (
        <Row className={styles.footer} style={{ width: "100%" }}>
            <Button
                className={styles.button}
                onClick={() => {
                    location.pathname !== Common.PAGE_MAIN && navigate(Common.PAGE_MAIN);
                }}
            >
                <HomeOutlined style={{ fontSize: 16 }} />홈
            </Button>

            <Button
                className={styles.button}
                onClick={() => {
                    location.pathname !== Common.PAGE_CAR_LOCATION && navigate(Common.PAGE_CAR_LOCATION);
                }}
            >
                <EnvironmentOutlined style={{ fontSize: 16 }} />
                차량위치
            </Button>

            <Button
                className={styles.button}
                onClick={() => {
                    location.pathname !== Common.PAGE_DIGITALKEY_LIST && navigate(Common.PAGE_DIGITALKEY_LIST);
                }}
            >
                <KeyOutlined style={{ fontSize: 16 }} />
                스마트키
            </Button>

            <Button
                className={styles.button}
                onClick={() => {
                    location.pathname !== Common.PAGE_MANUAL && navigate(Common.PAGE_MANUAL);
                }}
            >
                <FileTextOutlined style={{ fontSize: 16 }} />
                매뉴얼
            </Button>

            <Button
                className={styles.button}
                onClick={() => {
                    Utils.addModalStack();
                    Modal.confirm({
                        title: "로그아웃",
                        content: "로그아웃 하시겠습니까?",
                        okText: "확인",
                        onOk() {
                            Utils.popModalStack();
                            if (dispatch !== null) dispatch({ type: "LOGOUT" });
                            alert.setAlert(AlertType.SUCCESS, "로그아웃", "로그아웃 하였습니다.");
                            navigate(Common.PAGE_LOGIN, { replace: true });
                        },
                        cancelText: "취소",
                        onCancel() {
                            Utils.popModalStack();
                        },
                        centered: true,
                    });
                }}
            >
                <UserOutlined style={{ fontSize: 16 }} />
                로그아웃
            </Button>
        </Row>
    );
}

export default PageFooter;
